import { FC } from 'react';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { reviewService } from '@/services/review.service';
import styles from './FormReview.module.scss';
import { REG_EXP_WEB_LINK } from '@/helpers/variables';
import { checkSqlWords } from '@/helpers/helpers';

interface IFormReview {
  bookId: number;
  bookAlias: string;
  noMargin?: boolean;
  isCollectionPage?: boolean;
}

const FormReview: FC<IFormReview> = ({ bookId, bookAlias, noMargin, isCollectionPage }) => {
  const VALIDATION_NOT_PASS_TXT = 'Текст отзыва не прошел валидацию. Наберите еще раз.';
  const VALIDATION_PASS_TXT = 'Спасибо! Ваш отзыв был отправлен на модерацию.';

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: '',
      email: '',
      message: '',
      book_id: bookId,
      book_alias: bookAlias,
      status: 'active',
    },
  });

  const [isModerateNoteVisible, setIsModerateNoteVisible] = useState(false);
  const [moderationText, setModerationText] = useState('');

  const showModerationMessage = (text: string) => {
    setModerationText(text);
    setIsModerateNoteVisible(true);
    setTimeout(() => {
      setIsModerateNoteVisible(false);
    }, 2500);
  };

  return (
    <form
      className={noMargin ? `${styles.bookReviewForm} ${styles.bookReviewForm_noMargin}` : `${styles.bookReviewForm}`}
      onSubmit={handleSubmit((data) => {
        if (REG_EXP_WEB_LINK.test(data.message) || checkSqlWords(data.message)) {
          showModerationMessage(VALIDATION_NOT_PASS_TXT);
          return null;
        }

        if (isCollectionPage) {
          reviewService.postCollectionReview({ name: data.name, email: data.email, message: data.message, collection_id: data.book_id });
        } else {
          reviewService.postReview(data);
        }

        showModerationMessage(VALIDATION_PASS_TXT);
        reset();
      })}
    >
      <div className={`${styles.rateReviewNotice} ${styles.rateReviewNotice_new}`} data-review-notice>
        Спасибо за оценку! Будем признательны, если Вы оставите комментарий о данном произведении.
      </div>
      <h2 className={styles.label}>Добавить отзыв:</h2>

      <div className={styles.bookReviewForm__row}>
        <div className={styles.item}>
          <input {...register('name', { required: true, minLength: 3 })} placeholder="Ваше имя" className={errors.name ? `${styles.input} ${styles.errorBg}` : `${styles.input}`} />
          {errors.name && <span className={styles.errorMessage}>Никнейм должен быть больше 3 символов</span>}
        </div>

        <div className={styles.item}>
          <input {...register('email')} placeholder="Ваш email" className={`${styles.input} ${styles.recense_email}`} />
        </div>
      </div>

      <div className={styles.item}>
        <textarea {...register('message', { required: true, minLength: 8 })} placeholder="Что вы думаете о книге?" className={errors.message ? `${styles.textarea} ${styles.errorBg}` : `${styles.textarea}`} />
        {errors.message && <span className={styles.errorMessage}>Текст должен быть больше 8 символов</span>}
      </div>

      <div>
        <div className={styles.sendButton}>
          <input type="submit" value="Отправить" className={styles.btn} />
        </div>
      </div>
      {isModerateNoteVisible && <div className={moderationText.includes('не прошел') ? `${styles.bookReviewForm__moderationTxt} ${styles.bookReviewForm__moderationTxt_red}` : `${styles.bookReviewForm__moderationTxt}`}>{moderationText}</div>}
    </form>
  );
};

export default FormReview;
